import FormBudget from './Form/FormBudget'
import api from '../../utils/api'
import { useState, useEffect } from 'react'
/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

function EditBudget({ id, btCancelAction, handleOnSuccess, allowSellerSelect }) {
    const [budget, setBudget] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {

        api.get(`/order/budget/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            if (response) {
                setBudget(response.data.budget)
            }

        })
    }, [token, id])

    async function updateBudget(obj) {
        let msgType = 'success'
        const data = await api.patch(`/order/budget/update/${id}`, obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            }
        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }


    


    return (
        budget.code && (
            <FormBudget title="Editar Orçamento" handleSubmit={updateBudget} budgetData={budget} budgetItemArrayData={budget.orderItemArray} btCancelAction={btCancelAction} allowSellerSelect={allowSellerSelect} />
        )
    )
}

export default EditBudget